import { useMemo } from 'react';

// Libs
import { useQuery } from '@tanstack/react-query';
import {
  addMonths, addYears, isAfter, isBefore, isEqual, isWeekend, parse, subDays,
} from 'date-fns';

// Utils
import formulas from '../statics/formulas';

// Hooks
import useBookingForm from './useBookingForm';
import useDayId from './useDayId';

// Services
import holidaysService from '../services/holidays';

const useBookingDates = () => {
  const { data: holidaysData } = useQuery(['getHolidays'], holidaysService.getHolidays);
  const holidays = useMemo(() => (
    Object.keys(holidaysData || {})?.map((date) => parse(date, 'yyyy-MM-dd', new Date())) || []
  ), [holidaysData]);

  const { bookingForm, setFormData } = useBookingForm();
  const { getDayIdFromDate, getDateFromDayId } = useDayId();

  const isDayOff = (date) => (
    isWeekend(date)
    || holidays?.some((holiday) => isEqual(date, holiday))
  );

  // const getNearestAvailableDay = (day) => {
  //   if (isDate(day) && isDayOff(day)) {
  //     // take the day before if day is off
  //     return getNearestAvailableDay(subDays(day, 1));
  //   }

  //   return day;
  // };

  const isDayDisabled = ({
    view, date, prevStartValue, prevEndValue,
  }) => {
    if (view !== 'month') return false;

    if (isDayOff(date)) return true;

    // MS formula (user manual selection)
    // apply min and max limits for end date selection
    if (bookingForm?.formula === formulas.ms.value && prevStartValue && !prevEndValue) {
      const prevStartDate = getDateFromDayId(prevStartValue);

      // min = start + 1 month - 1 day
      const min = prevStartDate ? subDays(addMonths(prevStartDate, 1), 1) : null;
      // max = start + 6 months - 1 day
      const max = subDays(addMonths(prevStartDate, 6), 1);

      if (isBefore(date, min) || isAfter(date, max)) return true;
    }

    return false;
  };

  const setDates = ({ values }) => {
    const start = values?.[0] || null;
    let end = null;

    // LS formula
    if (bookingForm?.formula === formulas.ls.value) {
      // automatic calculation of end date based on start date : [start + 1 year - 1 day]
      end = start ? subDays(addYears(start, 1), 1) : null;

      // apply day off constraint
      // if (end) {
      //   end = getNearestAvailableDay(end);
      // }
    }

    // MS formula
    if (bookingForm?.formula === formulas.ms.value) {
      // user manual choice of end date
      end = values?.[1] || null;
    }

    setFormData({
      stayStart: getDayIdFromDate(start),
      stayEnd: getDayIdFromDate(end),
      apartment: null,
    });
  };

  return {
    isDayDisabled,
    setDates,
  };
};

export default useBookingDates;
